import React, {Component,useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    List,
    Card,
    Avatar,
    Popover,
    Select,
    Popconfirm,
    Form,
    Radio,
    Switch,
    Cascader,
    TreeSelect,
    notification,
    message
} from 'antd';
import { EditOutlined, DeleteOutlined, WechatOutlined } from '@ant-design/icons';
import 'moment/locale/zh-cn';
import moment from "moment";
const { Title,Text } = Typography;
const { Content } = Layout;
const { Meta } = Card;
const openNotification = () => {
    notification.open({
        message: '提交成功',
        description:
            '修改成功',
        onClick: () => {
            console.log('提交成功');
        },
    });
};
const info = () => {
    message.info('This is a normal message');
};
class PagePurClause extends Component{

    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        const level = params.get("level");
        let source = '';
        switch (level){
            case "1":
                source = "管理员"
                break;
            case "2":
                source = "业务员"
                break;
            case "3":
                source = "司机"
                break;
        }
        this.state = {
            title: "合同条款",
            source: source,
            county: [],
            id: id,
            level: level,
            list: []
        };
    }

    componentDidMount() {
        fetch("https://pd.pokemonbye.com:8084/api/getsellclausenew")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if(array!=null&&array.length>0){

                        this.setState({
                            isLoaded: true,
                            list: array[0]
                        })
                        this.formRef.current.setFieldsValue(array[0])
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }
    formRef = React.createRef();
    render() {
        const handleChange = (value) => {
            console.log(value)
            this.setState({
                client: value
            });
        };
        const onFinish = (values) => {
            function queryParse(query){
                let queryText = "";
                for(let key in query){
                    queryText += `${key}=${query[key]}&`;
                }
                return queryText.slice(0,-1);
            }
            var list = {};
            list.clause = values.clause ? values.clause : this.state.list.clause;
            list.deliver = values.delivery ? values.delivery : this.state.list.delivery;
            list.settle = values.settle ? values.settle : this.state.list.settle;

            fetch("https://pd.pokemonbye.com:8084/api/insertsellclause",
                {
                    method:'post',
                    body:queryParse(list),
                    headers:{
                        'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                    }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        openNotification();
                        window.location.reload();
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        };
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Form
                                    labelCol={{
                                        span: 4,
                                    }}
                                    wrapperCol={{
                                        span: 10,
                                    }}
                                    layout="horizontal"
                                    size="Large"
                                    onFinish={onFinish}
                                    ref={this.formRef}
                                >
                                    <Form.Item label="合同条款" name="clause">
                                        <Input.TextArea autoSize={true}/>
                                    </Form.Item>
                                    <Form.Item label="交货方式" name="delivery">
                                        <Input.TextArea autoSize={true}/>
                                    </Form.Item>
                                    <Form.Item label="结算方式" name="settle">
                                        <Input.TextArea autoSize={true}/>
                                    </Form.Item>
                                    <Form.Item
                                        wrapperCol={{
                                            offset: 4,
                                            span: 16,
                                        }}
                                    >
                                        <Button type="primary" htmlType="submit">提交修改</Button>
                                    </Form.Item>
                                </Form>

                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PagePurClause;


